<template>
  <div v-if="display">
    <modal-layout-top :title="title" />
    <div class="content slider-modal">
      <div class="columns">
        <div class="column has-text-right is-two-fifths">
          <label class="label select-list-label">Kund</label>
        </div>
        <div class="column">
          <model-list-select :list="customers"
                option-value="customerId"
                optionText="name"
                v-model="priceList.customerId"
                placeholder="Välj kund">
          </model-list-select>
        </div>
      </div>

      <div class="field is-horizontal" v-for="item in priceList.lines" :key="item.productId">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">{{ item.productName }}</label>
            </div>
            <p class="control is-expanded">
              <input type="number" class="input" v-model="item.price">
            </p>
          </div>
        </div>
      </div>

      <!--
      <div v-for="item in priceList.lines" :key="item.productId">
        <div class="field-body">
          <div class="field">
            <label class="label">{{ item.productName }}</label>
            <input type="number" class="input" v-model="item.price">
          </div>
        </div>
      </div>
      -->

      <input type="text" class="input" placeholder="Kommentar" v-model="priceList.comment">

      <hr>
      <modal-layout-buttons :store-name="'priceListCustomer'" />
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import { ModelListSelect } from 'vue-search-select'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'price-list-customer-modal',
  components: {
    ModelListSelect,
    ModalLayoutTop,
    ModalLayoutButtons
  },
  data () {
    return {
      priceList: { },
      isUpdate: false,
      display: false,
      customers: []
    }
  },

  props: {
    id: {
      type: Number,
      required: false
    }
  },
  computed: {
    title () {
      if (!this.isUpdate) {
        return 'Skapa ny prislista'
      } else {
        return 'Ändra prislista ' + this.priceList.customerName
      }
    }
  },
  methods: {
    ...mapActions('priceListCustomer', ['update', 'create', 'getById']),
    ...mapActions({
      'getAllCustomers': 'customers/getAll'
    }),
    closePanel () {
      this.$emit('closePanel')
    },
    save () {
      if (!this.priceList.customerId) {
        this.$toast('Välj vilken kund prislistan ska gälla för', 'info')
        return
      }

      if (this.isUpdate) {
        this.update(this.priceList).then(() => {
          this.closePanel()
        }).catch(() => {
          this.$toast('Felaktig data', 'error')
        })
      } else {
        this.create(this.priceList).then(() => {
          this.closePanel()
        })
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    this.getAllCustomers().then(customers => {
      this.customers = customers
    })

    this.getById(this.id).then((priceList) => {
      this.priceList = priceList
      this.display = true
    })
    this.isUpdate = this.id !== 0
  }
}
</script>

<style scoped>
  .select-list-label {
    line-height: 40px;
    vertical-align: middle;
  }
  .field-body {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/PriceListCustomerModal.vue